module.exports = __webpack_public_path__ + "img/rtb_silo_4.83578202.png";